<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100;">
            {{ hasEditPermission ? 'EDIT' : 'VIEW'}} {{ $route.name === 'EditJe' ? 'JOURNAL ENTRY' : 'PAYROLL ENTRY' }} {{ (form && form.number) ? form.number : '' }}
            ({{
              originalHeader && originalHeader.status
              ? originalHeader.status
              : ''
            }})
          </h2>
        </el-row>
      </el-col>
      <template>
        <el-button :disabled="disablePrevButton || isSaving" :loading="loadingPrev" @click.stop="pageNavigation('prev')" size="small">Previous</el-button>
        <el-button :disabled="disableNextButton || isSaving" class="mr-5" :loading="loadingNext" @click.stop="pageNavigation('next')" size="small">Next</el-button>
      </template>
      <DataEntryButtons
        :status="originalHeader.status"
        :isReadOnly="readOnly"
        :hasBeenChanged="hasBeenChanged"
        :amountHasChanged="amountHasChanged"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :isSaveable="isSaveable"
        :disableDistChanges="disableDistChanges"
        :disableAuditBtn="disableAuditBtn"
        :disablePostBtn="disablePostBtn"
        :transactionType="transactionType"
        :numberOfFiles="numberOfFiles"
        :isRecon="isRecon"
        :hasPermission="hasPermission"
        @addNew="addNew"
        @toggleReadOnly="toggleReadOnly"
        @dropdownClick="handleDropdownClick"
        @goBack="goBack"
        @auditBtnClick="handleAuditBtnClick('Journal Entry')"
        @postBtnClick="handlePostBtnClick('Journal Entry')"
        @otherActions="otherActions"
        @submit="handleSubmit"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
      <el-row justify="start" align="start" type="flex" class="trx-header" ref="trxHeaderContainer">
      <el-col :span="8" style="margin-right: 10px">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin: 0 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Data"
            :fields="fields.jeData"
            :form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @acBackspaceEvent="updateForm"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin-left: 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Info"
            :fields="fields.transactionInfo"
            :form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="je"
        ref="distribution-lines"
        :fields="prLineFields"
        :readOnly="readOnly || isSaving"
        :existingLines="[...lines]"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :initLines="20"
        :vendorPoLines="getPoLines"
        :fetchingPoLines="fetchingPoData"
        :hasEditPermission="hasEditPermission"
        :hasDeletePermission="hasDeletePermission"
        :disableLineDeletion="true"
        @viewDc="viewDc"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @updateLines="updateLines"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      :visible.sync="dialogVisible"
      size="tiny"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Do you wish to save your changes?
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="exit-modal-btn"
          @click="cancelExit">
          Cancel
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          @click="goBack(true)">
          No
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          @click="handleSubmit(false)">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="docs-dialog"
      title="View/Upload Documents"
      size="small"
      top="10%"
      :visible.sync="dropzoneVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <document-dialog
        :transaction="form"
        :dz-options="setupDropzoneOptions()"
        @upload-success="dzSuccess"
        @upload-error="dzFailure"
        @upload-remove="dzRemove"
      />
    </el-dialog>
    <NewBatch :hasCreatePermission="hasCreateBatchPermission" @populateFieldWithNewModel="populateFieldWithNewModel" />
    <DcConfirmationDialog
      :originalLines="originalLines"
      :lineDeltas="lineDeltas"
      :lineFields="lineFields"
      :visible="dcConfirmationDialogVisible"
      :allDcs="allDcs"
      :newDcs="newDcs"
      :existingDcs="existingDcs"
      :loading="creatingDc"
      @cancel="() => showDcConfirmationDialog(false)"
      @confirm="confirmDcSubmit"
    />
    <DcViewDialog
      :viewedDcId="viewedDcId"
      :viewableDcs="viewableDcs"
      :showOrClose="viewDc"
      :trxType="transactionType.name"
      :lineFields="lineFields"
      :trxId="originalHeader.id"
    />
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew1.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import { isJeBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { trackHeaderChanges, trackDistributionChanges } from '@/utils/helpers/DataEntryViews/TrackChanges'
  // import sortLines from '@/utils/helpers/DataEntryViews/SortLines'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { transactionEditViewMixins } from '@/Mixins/TransactionEditViews'
  import DocumentDialog from '@/components/DocumentDialog.vue'
  import LinesLoading from '@/components/LinesLoading.vue'
  import FindOrFetchBatchAndPeriod from '@/utils/helpers/DataEntryViews/FindOrFetchBatchAndPeriod'
  import { payload as sourcecodePayload } from '@/components/RouteComponents/Sourcecodes/actionPayload'
  import DcConfirmationDialog from '@/components/DcConfirmationDialog.vue'
  import DcViewDialog from '@/components/DcViewDialog.vue'
  import store from '@/store/store'
  import { getOffsetDcJeLines, getPoLinesToRelieve, loadInitialData } from '@/utils/helpers/DataEntryViews/BeforeRouteEnterHelpers'

  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      DataEntryButtons,
      DocumentDialog,
      LinesLoading,
      DcConfirmationDialog,
      DcViewDialog
    },
    mixins: [ transactionMixins, transactionEditViewMixins ],
    data () {
      const { getJeById, getBatchById, getSourcecodeById, getJeLinesByTransactionId, checkIfUserHasRequiredPermissions } = this.$store.getters
      const je = getJeById(this.$route.params.id)
      let lines = this.buildLinesWithDcs(Object.values(getJeLinesByTransactionId(je.id)), je)
      return {
        transactionType: { name: 'je', path: '/jes/', prettyName: 'Payroll' },
        originalHeader: je,
        originalLines: lines,
        lines,
        form: {
          batch: { label: je.batch ? getBatchById(je.batch).name : '', value: je.batch || '' },
          period: je.period || '',
          source_code: { label: je.source_code ? `${getSourcecodeById(je.source_code).code} - ${getSourcecodeById(je.source_code).name}` : '', value: je.source_code || '' },
          description: je.description || '',
          date: je.date || '',
          number: je.number || '',
          debits_decimal: je.debits_decimal || '',
          credits_decimal: je.credits_decimal || '',
          confirmation_number: je.confirmation_number || '',
          original_trx_number: je.original_trx_number || '',
          effective_date: je.effective_date || '',
          status: je.status,
          amount_decimal: je.amount_decimal || ''
        },
        headerDeltas: {},
        lineDeltas: {},
        loadingOptions: false,
        dialogVisible: false,
        readOnly: !['DRAFT', 'OPEN', 'AUDITED'].includes(je.status) || (['DRAFT', 'OPEN', 'AUDITED'].includes(je.status) && !checkIfUserHasRequiredPermissions(['entry.view_payrollentry', 'entry.add_payrollentry'])) || (['POSTED'].includes(je.status) && !checkIfUserHasRequiredPermissions(['entry.view_payrollentry', 'entry.add_payrollentry', 'entry.post_payrollentry'])),
        changesWereSaved: false,
        transactionIsBalanced: !(parseFloat(je.credits_decimal) + parseFloat(je.debits_decimal)),
        transactionWasBalanced: false,
        isOpenable: false,
        amountHasChanged: false,
        statusToRestore: '',
        altRoute: null,
        ready: false,
        disableAuditBtn: false,
        disablePostBtn: false,
        isSaving: false,
        notificationBox: undefined,
        dropzoneVisible: false,
        disablePrevButton: true,
        disableNextButton: true,
        loadingPrev: false,
        loadingNext: false,
        paginationData: []
      }
    },
    methods: {
      goBack (reset = false) {
        if (reset) this.hasBeenChanged = false
        this.ready = false
        this.resetInvalidChanges()
        if (this.altRoute && Object.keys(this.altRoute).length) {
          this.$router.push(this.altRoute)
        } else {
          this.$router.push({ name: this.$route.name === 'EditJe' ? 'JEs' : 'PRs' })
        }
      },
      resetInvalidChanges () {
        if (this.originalHeader.status === 'POSTED' && this.amountHasChanged) {
          this.lineDeltas = Object.assign({})
          const headerChanges = Object.keys(this.headerDeltas)
          if (headerChanges.includes('debits_decimal')) {
            delete this.headerDeltas['debits_decimal']
          }
          if (headerChanges.includes('credits_decimal')) {
            delete this.headerDeltas['credits_decimal']
          }
          this.checkForChanges()
        }
      },
      /**
       * Submits the form.
       * @param saveOnly        Enables or disables any navigation that should occur after the transaction is saved
       * @param explicitDeltas  Specifies hard-coded deltas that need to be set, such as status
       * @param reportToRun     Specifies type of report to run once saved. Can be 'audit' or 'posting'
       */
      handleSubmit (saveOnly, explicitDeltas = null, reportToRun = null) {
        if (this.shouldCreateDcJe) {
          this.showDcConfirmationDialog(true)
          return
        }
        if (this.dialogVisible) {
          this.handleDialogVisible(false)
        }
        let removedLines = this.removeDeletedLines()
        const { headerDeltas, lineDeltas } = this
        if (explicitDeltas) {
          this.headerDeltas = Object.assign(headerDeltas, explicitDeltas)
        }
        const hDeltaCount = Object.keys(headerDeltas).length
        const lDeltaCount = Object.keys(lineDeltas).length
        if (hDeltaCount || lDeltaCount) {
          this.isSaving = true
          this.saveTransactionChanges('Je', saveOnly, reportToRun)
        } else {
          this.transactionIsBalanced = isJeBalanced(this)
          this.checkForChanges()
          if (removedLines.length) {
            removedLines.forEach(lineNum => this.$refs['distribution-lines'].removeLine(lineNum))
          }
        }
      },
      /**
       * Updates header form
       * @param form
       */
      updateForm (form) {
        this.form = Object.assign({}, form)
        this.headerDeltas = trackHeaderChanges(this.form, this.originalHeader)
        this.checkForChanges()
      },
      /**
       * Updates distribution lines
       * @param lines
       */
      updateLines (lines) {
        this.lines = lines
        this.linesChanged()
        this.updateDebitsAndCredits()
      },
      /**
       * Fires certain actions when distribution lines are changed
       */
      linesChanged () {
        this.lineDeltas = trackDistributionChanges(this.lines, this.originalLines)
        const d = this.lineDeltas
        if (d.hasOwnProperty('new') || Object.values(d).some(v => v.hasOwnProperty('amount_decimal'))) {
          this.updateForm(this.form)
        }
        this.checkForChanges()
      },
      /**
       * Updates JE debits and credits based on distribution line balances
       */
      updateDebitsAndCredits () {
        let debits = 0
        let credits = 0
        this.lines.forEach(line => {
          if (line && line.deleteLine) return
          const amount = parseFloat(line.form.amount_decimal)
          if (amount && amount >= 0) {
            debits = debits + amount
          } else if (amount && amount < 0) {
            credits = credits + amount
          }
        })
        this.form.debits_decimal = (Math.round(debits * 100) / 100).toFixed(2)
        this.form.credits_decimal = (Math.round(credits * 100) / 100).toFixed(2)
        this.transactionIsBalanced = isJeBalanced(this)
        this.updateForm(this.form)
      },
      /**
       * Updates the header's "status" field
       */
      updateHeaderStatusField () {
        let tmp = Object.assign({}, this.form)
        tmp.status = this.originalHeader.status
        this.form = Object.assign({}, tmp)
      },
      /**
       * Disables header fields
       * TODO: deprecate
       */
      disableHeaderFields () {
        let tmpFields = Object.assign({}, this.fields)
        tmpFields.batch.inputFields.map(v => {
          if (v.name === 'batch') {
            v.disabled = true
            v.addBtn = false
          }
          return v
        })
        this.fields = Object.assign({}, tmpFields)
      },
      /**
       * Determines whether or not this transaction status can be set to 'OPEN'
       */
      checkIfOpenable () {
        const { transactionWasBalanced, transactionIsBalanced, lines } = this
        this.isOpenable = (transactionWasBalanced || transactionIsBalanced) && (lines && lines.length) // TODO: && lines are valid?
      },
      async pageNavigation (type) {
        // Get the index of the current AP ( Current route id)
        let transactionIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
        let prevAndNextId = parseInt(this.$route.params.id)
        if (transactionIndex >= 0) {
          // Check Index is greater than zero and type is 'next'
          if (type === 'next') {
            this.loadingNext = true
            // Check upcoming Record is exist or not
            let checkNextId = this.paginationData[transactionIndex + 1]
            if (!checkNextId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkNextId).length) {
              prevAndNextId = checkNextId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'next' button
            this.disableNextButton = !this.paginationData[transactionIndex + 2]
          } else if (type === 'prev') {
            this.loadingPrev = true
            // Check upcoming Record is exist or not
            let checkPrevId = this.paginationData[transactionIndex - 1]
            if (!checkPrevId) {
              prevAndNextId = parseInt(this.$route.params.id)
            } else if (Object.keys(checkPrevId).length) {
              prevAndNextId = checkPrevId.id
            }
            // Check next id is exist or not for upcoming record and based on it we can disable the 'previous' button
            this.disablePrevButton = !this.paginationData[transactionIndex - 2]
          }
        }
        // Refresh the data without reloading the page
        this.refreshPage(prevAndNextId)
      },
      // Its copy of 'beforeRouteEnter': To refresh the data
      async refreshPage (routeId) {
        const { getJeById } = store.getters
        try {
          const resp = await store.dispatch('fetchCompactLineJesWithQuery', { query: { id: routeId, compact_lines: true }, storeLines: true })
          let promises = [
            store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
            store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
          ]
          if (resp && resp.entities) {
            const deps = await store.dispatch('findDependencies', resp.entities) || []
            promises = [...promises, ...deps]
          }
          const payload = Object.assign({}, sourcecodePayload, { query: { code: 'PR' } })
          promises.push(store.dispatch('fetchWithQuery', payload))
          await Promise.all(promises)
          const je = getJeById(routeId)
          await getPoLinesToRelieve(je.id, 'je')
          if (['POSTED', 'CLOSED', 'VOIDED', 'DELETED'].includes(je.status)) {
            await getOffsetDcJeLines(routeId, 'je')
          }
          promises = [...FindOrFetchBatchAndPeriod(store, je)]
          if (promises.length) {
            await Promise.all(promises)
          }
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
        } catch (e) {
          // To push the route in the URL
          if (routeId) {
            this.$router.push({ params: { id: routeId } })
          }
          console.log(e)
        }
      },
      async customCreated () {
        // To Prepare Query params to pass to the API
        let selectedStatuses = ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'VOIDED', 'CLOSED']
        let paginationQuery = { status__in: selectedStatuses }
        // Fetch 'paginationQuery' data is exist or not from the session storage
        let sessionStorageQuery = sessionStorage.getItem('paginationQuery')
        // Add pagination query in the session storage
        if (sessionStorageQuery) paginationQuery = JSON.parse(sessionStorageQuery)
        // Fetch 'paginationInfo' data is exist or not from the session storage
        let validatePaginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        let entities = []
        let response = []
        let trnSourceCode = 5
        const prSourcecode = this.$store.getters.getAllSourcecodes.find(sc => sc && sc.code === 'PR')
        if (prSourcecode && prSourcecode.id) {
          trnSourceCode = prSourcecode.id
        }
        try {
          // API to get the results based on the Query
          entities = await store.dispatch('fetchJesWithQuery', paginationQuery)
          response = this.$store.getters.getJes.filter(x => x.source_code === trnSourceCode) || []

          // Check and assign the response data
          if (!validatePaginationData) {
            validatePaginationData = response.sort((a, b) => b.id - a.id)
          }
          // Check unique data is exist or not
          if (validatePaginationData) sessionStorage.setItem('paginationInfo', JSON.stringify(validatePaginationData))
          else sessionStorage.setItem('paginationInfo', JSON.stringify(response.sort((a, b) => b.id - a.id)))
          // Assign pagination info to the paginationData
          this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
        } catch (error) {
          console.error()
        }
        this.disablePrevButton = false
        this.disableNextButton = false
        if (this.paginationData && this.paginationData.length > 0) {
          // To get the current index
          let getIndex = this.paginationData.findIndex(v => parseInt(v.id) === parseInt(this.$route.params.id))
          // Check index value is zero then disable prev button
          if (getIndex === 0) {
            if (entities) {
              if (!entities.previous) {
                this.disablePrevButton = true
              }
              if (!entities.next && getIndex === this.paginationData.length - 1) {
                this.disableNextButton = true
              }
              if (entities.previous) {
                paginationQuery['page'] = Number(paginationQuery['page']) - 1
                try {
                  // API to get the results based on the Quey param
                  entities = await store.dispatch('fetchJesWithQuery', paginationQuery)
                  response = this.$store.getters.getJes.filter(x => x.source_code === trnSourceCode) || []
                  let totalPaginationData = [...validatePaginationData, ...response]
                  // Update 'paginationInfo' data in the session storage
                  sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                  // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                  this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                  sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
                } catch (error) {
                  console.error()
                }
              }
            }
          } else if (getIndex === this.paginationData.length - 1) {
            // Check next available page is exist or not
            if (!entities || !entities.next) {
              this.disableNextButton = true
            } else {
              paginationQuery['page'] = Number(paginationQuery['page']) + 1
              try {
                // API to get the results based on the Quey param
                entities = await store.dispatch('fetchJesWithQuery', paginationQuery)
                response = this.$store.getters.getJes.filter(x => x.source_code === trnSourceCode) || []
                let totalPaginationData = [...validatePaginationData, ...response]
                // Update 'paginationInfo' data in the session storage
                sessionStorage.setItem('paginationInfo', JSON.stringify(totalPaginationData.sort((a, b) => b.id - a.id)))
                // Assign 'paginationInfo' to the 'paginationData' to do next and prev
                this.paginationData = JSON.parse(sessionStorage.getItem('paginationInfo'))
                sessionStorage.setItem('paginationQuery', JSON.stringify(paginationQuery))
              } catch (error) {
                console.error()
              }
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        getJes: 'getJes',
        getJeById: 'getJeById',
        getJeLines: 'getJeLines',
        getPoLines: 'getPoLines',
        getLineById: 'getLineById',
        getJeLinesByTransactionId: 'getJeLinesByTransactionId',
        getPeriodById: 'getPeriodById',
        currentPeriod: 'getCurrentPeriod',
        checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions',
        checkIfUserHasAnyOfThePermissions: 'checkIfUserHasAnyOfThePermissions'
      }),
      selectedPeriod () {
        const je = this.getJeById(this.$route.params.id)
        if (je && je.period && this.getPeriodById(je.period).id) {
          return this.getPeriodById(je.period)
        }
      },
      hasCreatePermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_payrollentry', 'entry.add_payrollentry'])
      },
      hasPostPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_payrollentry']) && this.checkIfUserHasAnyOfThePermissions(['entry.post_payrollentry', 'auth.post_transactions'])
      },
      hasEditPermission () {
        if (['POSTED', 'CLOSED'].includes(this.originalHeader.status)) return this.hasPostPermission
        else return this.hasCreatePermission
      },
      hasDeletePermission () {
        return this.hasCreatePermission && this.checkIfUserHasRequiredPermissions(['entry.delete_payrollentry'])
      },
      hasCreateBatchPermission () {
        return this.checkIfUserHasRequiredPermissions(['entry.view_batch', 'entry.add_batch'])
      },
      hasReadPermission () {
        let readPermission = ['entry.view_payrollentry']
        return this.checkIfUserHasRequiredPermissions(readPermission)
      },
      hasPermission () {
        return {
          read: this.hasReadPermission,
          create: this.hasCreatePermission,
          edit: this.hasEditPermission,
          delete: this.hasDeletePermission,
          post: this.hasPostPermission
        }
      },
      fields () {
        const c = this.getJeById(this.$route.params.id)
        let fields = {
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'batches' },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a batch',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) && this.hasCreateBatchPermission
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          jeData: {
            inputFields: [
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission,
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'number',
                label: this.$route.name === 'EditJe' ? 'Journal Number e' : 'Payroll Number',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: this.unAllowedStatusesToChange.includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'amount_decimal',
                label: 'Amount',
                dataType: 'string',
                fieldType: 'money',
                disabled: true
              },
              {
                name: 'date',
                label: this.$route.name === 'EditJe' ? 'Date' : 'Week Ending',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                msg: 'Please specify a date'
              },
              {
                name: 'effective_date',
                label: 'Effective Date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                fieldType: 'date',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'confirmation_number',
                label: 'Confirmation',
                dataType: 'string',
                fieldType: 'input',
                disabled: ['CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission
              },
              {
                name: 'source_code',
                label: 'Source code',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'sourcecodes' },
                triggerOnFocus: false,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || this.$route.name === 'EditPr' || !this.hasEditPermission
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                remote: false,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(c.status) || !this.hasEditPermission,
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Debits',
                field: 'debits_decimal',
                value: '',
                useFormValue: true,
                prefix: this.currency ? this.currency.symbol : ''
              },
              {
                label: 'Credits',
                field: 'credits_decimal',
                value: '',
                useFormValue: true,
                prefix: this.currency ? this.currency.symbol : ''
              },
              {
                label: 'Transaction #',
                value: c.ledger || ''
              },
              {
                label: 'Date posted',
                value: c.time_posted ? this.formatDateToLocale(c.time_posted) : ''
              },
              {
                label: 'Status',
                value: '',
                useFormValue: true,
                field: 'status'
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.jeData.inputFields[7].options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
          fields.jeData.inputFields[7].options.push({
            label: `Ending ${this.selectedPeriod.end}`,
            value: this.selectedPeriod.id,
            selected: true
          })
        }
        return fields
      },
      isRecon () {
        if (this.batchAttributes.bank) {
          let lines = Object.values(this.getJeLinesByTransactionId(this.$route.params.id))
          return lines.filter(l => (l.recon !== null && (l.bank === this.batchAttributes.bank.id))).length > 0
        }
      }
    },
    watch: {
      getJes () {
        const newHeader = this.getJeById(this.originalHeader.id)
        if (newHeader) {
          this.originalHeader = Object.assign({}, newHeader)
          this.updateHeaderStatusField()
          this.readOnly = !['DRAFT', 'OPEN', 'AUDITED'].includes(this.originalHeader.status) || !this.hasEditPermission
        }
      },
      getJeLines () {
        if (this.voidingDcJes) {
          return
        }
        const recent = () => {
          let incoming = Object.values(this.getJeLinesByTransactionId(this.$route.params.id))
          return this.buildLinesWithDcs(incoming, this.getJeById(this.$route.params.id))
        }
        if ((this.ready || this.isDCUpdated) && (JSON.stringify(recent()) !== JSON.stringify(this.originalLines))) { // this.ready prevents this logic from running when component is created
          this.originalLines = recent()
          this.lines = recent()
          if (this.$refs && this.$refs['distribution-lines']) {
            this.$refs['distribution-lines'].rebuildLines()
          }
          if (this.isDCUpdated) this.isDCUpdated = false
        }
        this.ready = !this.isSaving
      },
      /**
       * Determines whether the transaction's amount has changed
       */
      headerDeltas () {
        const deltas = Object.keys(this.headerDeltas)
        this.amountHasChanged = deltas.includes('debits_decimal') || deltas.includes('credits_decimal')
      }
    },
    /**
     * Things that should be done when the component is created
     */
    async created () {
      await this.customCreated()
      // this.lines = sortLines(this.lines)
      this.transactionWasBalanced = isJeBalanced(this)
      if (this.originalHeader === 'DRAFT') this.checkIfOpenable()
      this.linesChanged()
      this.updateDebitsAndCredits()
    },
    /**
     * Things that should be done before the route resolves and the component is created
     * @param to
     * @param from
     * @param next
     * @return {Promise<void>}
     */
    async beforeRouteEnter (to, from, next) {
      const { getJeById } = store.getters
      try {
        const resp = await store.dispatch('fetchCompactLineJesWithQuery', { query: { id: to.params.id, compact_lines: true }, storeLines: true })
        let promises = [
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
          store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
        ]
        if (resp && resp.entities) {
          const deps = await store.dispatch('findDependencies', resp.entities) || []
          promises = [...promises, ...deps]
        }
        if (to.name === 'EditPr') {
          const payload = Object.assign({}, sourcecodePayload, { query: { code: 'PR' } })
          promises.push(store.dispatch('fetchWithQuery', payload))
        }
        await Promise.all(promises)
        const je = getJeById(to.params.id)
        await getPoLinesToRelieve(je.id, 'je')
        await loadInitialData()
        // if (['POSTED', 'CLOSED', 'VOIDED', 'DELETED'].includes(je.status)) {
        //   await getOffsetDcJeLines(to.params.id, 'je')
        // }
        promises = [...FindOrFetchBatchAndPeriod(store, je)]
        if (promises.length) {
          await Promise.all(promises)
        }
        next()
      } catch (e) {
        console.log(e)
        // TODO: notify user
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        sessionStorage.removeItem('paginationInfo')
        sessionStorage.removeItem('paginationQuery')
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Prs/Edit.vue